"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var HeaderNav = function HeaderNav(_ref) {
  var navTabs = _ref.navTabs,
      logo = _ref.logo,
      className = _ref.className,
      currentLocation = _ref.currentLocation,
      _onClick = _ref.onClick,
      logoOnClick = _ref.logoOnClick,
      otherProps = _objectWithoutProperties(_ref, ["navTabs", "logo", "className", "currentLocation", "onClick", "logoOnClick"]);

  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(LogoContainer, null, /*#__PURE__*/_react.default.createElement(Logo, {
    src: logo,
    alt: "WeGroup",
    onClick: logoOnClick
  })), /*#__PURE__*/_react.default.createElement(Navigation, null, navTabs.map(function (tab) {
    var to = tab.to;
    return /*#__PURE__*/_react.default.createElement(NavItem, {
      onClick: function onClick() {
        return _onClick(to);
      },
      key: tab.title,
      active: to === currentLocation,
      "data-test-id": tab.title
    }, tab.title);
  }))));
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper"
})(["position:relative;display:flex;justify-content:space-between;align-items:center;width:100%;height:100%;"]);

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container"
})(["height:8rem;width:100%;position:fixed;top:0;background:#fbfbfb;border-bottom:0.2px solid #e2e2e2;box-shadow:0 0 0.5rem rgba(0,0,0,0.1);z-index:11;padding:0 7rem 0 2.5rem;box-sizing:border-box;"]);

var NavItem = _styledComponents.default.li.withConfig({
  displayName: "NavItem"
})(["cursor:pointer;margin:0 3rem;font-size:1.6rem;padding:2.5rem 2rem 2rem;font-family:", ";border-bottom:", ";border-color:", ";font-weight:", ";color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (props) {
  return props.active === true ? "3px solid" : 'none';
}, function (_ref3) {
  var theme = _ref3.theme,
      active = _ref3.active;
  return active === true ? theme.brand.primary : 'none';
}, function (props) {
  return props.active === true ? "500" : 'none';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typo.highlight;
});

var Navigation = _styledComponents.default.ul.withConfig({
  displayName: "Navigation"
})(["display:flex;padding-top:2rem;position:absolute;left:50%;transform:translateX(-50%);"]);

var LogoContainer = _styledComponents.default.div.withConfig({
  displayName: "LogoContainer"
})(["height:60%;"]);

var Logo = _styledComponents.default.img.withConfig({
  displayName: "Logo"
})(["height:100%;", ""], function (_ref5) {
  var onClick = _ref5.onClick;
  return onClick ? 'cursor:pointer' : null;
});

HeaderNav.defaultProps = {
  navTabs: [],
  onClick: function onClick() {},
  otherProps: {}
};
HeaderNav.propTypes = {
  navTabs: _propTypes.array,
  logo: _propTypes.string,
  className: _propTypes.string,
  onClick: _propTypes.func,
  logoOnClick: _propTypes.func,
  currentLocation: _propTypes.string,
  otherProps: _propTypes.object
};
var _default = HeaderNav;
exports.default = _default;